/**
 * @author        matthew@zumper.com (Matthew Talamini)
 * @copyright     Copyright (c) 2025, Zumper
 * @description   ContentModuleAmenities bizo
 */

import { Bizo, autoclass } from './base'
import type {
  ContentModuleAmenities as ContentModuleAmenitiesType,
  RawContentModuleAmenities,
} from './contentModuleAmenities.types'

export const ContentModuleAmenities: typeof ContentModuleAmenitiesType = autoclass<
  ContentModuleAmenitiesType,
  RawContentModuleAmenities
>(
  'ContentModuleAmenities',
  class ContentModuleAmenities extends Bizo<
    ContentModuleAmenitiesType,
    RawContentModuleAmenities
  > {},
  {
    amenities: 'amenities',
    region: 'region',
    propertyType: 'property_type',
  }
)

export type ContentModuleAmenities = ContentModuleAmenitiesType
